import { useEffect } from 'react';

import {
	useAvailableSitesState,
	useMappingsActions,
} from '../providers/BulkConfigureContextProvider';
import { useIssueCreateSidePanelContext } from '../providers/IssueCreateSidePanelContextProvider';
import { getJiraWorkItemKeysFromTable } from '../utils/tableUtils';

import { fetchBulkWorkItemTypes } from './apiUtils';
import { IssueType } from '../providers/BulkCreateContextProvider';
import { JiraIssueKeysToTypes } from '../__types__/apiUtils';

const BATCH_SIZE = 20;

export const useGetMappedJiraWorkItemTypes = () => {
	const [{ selectedTable }] = useIssueCreateSidePanelContext();
	const { selectedAvailableSite } = useAvailableSitesState();
	const { setMappingWorkItemTypes } = useMappingsActions();

	useEffect(() => {
		const fetchWorkItemTypes = async () => {
			const cloudId = selectedAvailableSite?.cloudId;
			if (!selectedTable || !cloudId) {
				return;
			}
			const allWorkItemKeysFlat = Array.from(
				getJiraWorkItemKeysFromTable(selectedTable).values(),
			).flat();
			const batches: string[][] = [];

			for (let i = 0; i < allWorkItemKeysFlat.length; i += BATCH_SIZE) {
				batches.push(allWorkItemKeysFlat.slice(i, i + BATCH_SIZE));
			}

			const fetchPromises = batches.map((batch) =>
				fetchBulkWorkItemTypes({ cloudId, workItemKeys: batch }),
			);

			const fetchResults = await Promise.all(fetchPromises);

			// Accumulate results from all batches into a single Map
			const results: JiraIssueKeysToTypes = fetchResults
				.filter((batchResult): batchResult is JiraIssueKeysToTypes => batchResult != null)
				.reduce((acc: JiraIssueKeysToTypes, batchResult: JiraIssueKeysToTypes) => {
					batchResult.forEach((value, key) => {
						acc.set(key, value);
					});
					return acc;
				}, new Map<string, IssueType>());

			setMappingWorkItemTypes(results);
		};
		void fetchWorkItemTypes();
	}, [selectedTable, selectedAvailableSite?.cloudId, setMappingWorkItemTypes]);
};
